import { Component } from '@angular/core';

import { BasicService } from '../../services/basic.service';

@Component({
  selector: 'app-vip-bullet',
  template: '{{ vip }}',
  styleUrls: ['./vip-bullet.component.scss'],
})
export class VipBulletComponent {
  vip: string;

  constructor(private basicService: BasicService) {
    this.vip = this.basicService.translate('m/vip');
  }
}
